import React, { FC, useState } from 'react'
import { ChannelTeamItem } from 'pages/native/onBoarding/types/types'
import { Skeleton } from 'pages/native/onBoarding/components'

import styles from './TeamLogo.module.scss'

interface TeamLogoProps {
  team: ChannelTeamItem
}

export const TeamLogo: FC<TeamLogoProps> = ({ team }) => {
  const [isLoaded, setIsLoaded] = useState(false)

  return (
    <div className={styles.TeamLogoWrapper}>
      {!isLoaded && <Skeleton type="image" width={24} height={24} radius={2} />}
      <img
        src={team.logoUrl}
        alt={team.name}
        className={`${styles.TeamLogo} ${isLoaded ? styles.loaded : ''}`}
        onLoad={() => setIsLoaded(true)}
        style={{ display: isLoaded ? 'block' : 'none' }}
      />
    </div>
  )
}
